import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../assets/logo-suite241.png'


const _hoisted_1 = {
  key: 0,
  class: "login-welcome-overlay",
  role: "status",
  "aria-live": "polite",
  "aria-atomic": "true",
  "aria-busy": "true"
}
const _hoisted_2 = { class: "login-welcome-overlay__content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.visible)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "login-welcome-overlay__logo-wrap" }, [
            _createElementVNode("span", {
              class: "login-welcome-overlay__ring",
              "aria-hidden": "true"
            }),
            _createElementVNode("img", {
              class: "login-welcome-overlay__logo",
              src: _imports_0,
              alt: "Suite241"
            })
          ], -1)),
          _createElementVNode("h1", null, "Bienvenue, " + _toDisplayString(_ctx.welcomeName) + " !", 1)
        ])
      ]))
    : _createCommentVNode("", true)
}